<template>
<modal id="employee" name="employee-tradePoint">

    <b-container class="p-0">

        <b-container class="modal-employeeTT-container-top" 
                     :class="employees.length > 3 ? 'top-from-border' : ''">

            <b-row id="modal-employeeTT-close" @click="hideEmployeeTTModal">

                <span class="cursor-pointer">
                    <font-awesome-icon icon="times" class="icon-close" />
                </span>                    

            </b-row>

            <b-row class="text modal-employeeTT-title">
                ТТ сотрудников
            </b-row>

            <b-row class="m-20">

                <b-input-group>

                    <b-input-group-prepend id="modal-search-background-icon" 
                                           class="filter-trade-point-search-background-icon">

                        <font-awesome-icon icon="search" class="filter-trade-point-search-icon"/>
                    </b-input-group-prepend>

                    <b-input class="modal-employeeTT-search-input"
                                placeholder="Поиск сотрудников"
                                @input="searchEmployeeTT"/>

                </b-input-group>
                
            </b-row>

            <b-row class="m-20">
                <b-button-group>

                    <b-button class="text modal-employeeTT-combine-button" 
                                :class="isRouteLocal ? 'check' : ''" 
                                @click="setRoute(true)">
                        Маршруты сотрудников
                    </b-button>

                    <b-button class="text modal-employeeTT-combine-button" 
                                :class="!isRouteLocal ? 'check' : ''"
                                @click="setRoute(false)">
                        ТТ сотрудников
                    </b-button>

                </b-button-group>
            </b-row>

            <b-row id="modal-employeeTT-row-select-all">

                <b-form-checkbox id="checkbox-0" 
                                 class="employee-TT-checkbox"
                                 @change="chooseAll">

                    <b-list-group-item class="text modal-employeeTT-select-all" 
                                       :class="employees.length > 3 ? '' : 'without-margin-bottom'">
                        Выбрать всех
                    </b-list-group-item>

                </b-form-checkbox>
            </b-row>

        </b-container>

        <b-container class="modal-employeeTT-container-main" 
                     :class="employees.length > 3 ? 'small' : ''">

            <b-row v-for="(item, index) in employees" 
                :key="index" 
                class="modal-employeeTT-container-main-row">

                <b-container class="p-0" :class="employees.length > 3 ? 'm--4' : 'm--8'">
                    <span>
                        <b-form-checkbox :id="'checkbox-' + (index + 1)"
                                         class="employee-TT-checkbox"
                                         v-model="item.Checked"
                                         @change="sortEmployees(item)">

                            <b-container class="modal-employeeTT-container-employee">   

                                <b-row class="modal-employeeTT-container-row-employee">
                                    <b-col class="text modal-employeeTT-container-employee-name">
                                        {{item.Fio}}
                                    </b-col>
                                    <b-col cols="2" class="text modal-employeeTT-container-employee-id">
                                        DaxID: {{item.DaxUserId}}
                                    </b-col>
                                </b-row>

                                <b-row class="text modal-employeeTT-container-employee-position">
                                    {{item.Position}}
                                </b-row>

                            </b-container>

                        </b-form-checkbox>
                    </span>
                </b-container>

            </b-row>                  

        </b-container>

        <b-container class="modal-employeeTT-container-footer" 
                     :class="employees.length > 3 ? 'footer-from-border' : ''">

            <b-row id="footer" class="m-20 footer">

                <b-button id="modal-employeeTT-button-apply" 
                            class="text modal-employeeTT-button"
                            @click="applyClick">
                    Применить
                </b-button>

            </b-row>

        </b-container>

    </b-container>
</modal>

</template>

<script>
import '@/assets/styles/client/tradePoints/employeeTradePoint.css'

export default {
    props: {
        options: {
            type: [Object, Array],
            default: null
        },
        isRoute: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
            return {
                employees: [...new Set([...this.options.filter(e => e.Checked), ...this.options.sort((a, b) => (a.Fio > b.Fio) - (a.Fio < b.Fio))])],
                currentDisplayTT: this.displayTT,
                isRouteLocal: this.isRoute
            }
        },
        methods: {
            hideEmployeeTTModal: function() {
                this.$modal.hide('employee-tradePoint');
            },
            chooseAll: function(value) {
                this.employees.forEach((e) => {
                    e.Checked = value;
                });

                this.employees = [...new Set([...this.options.filter(e => e.Checked), ...this.options.sort((a, b) => (a.Fio > b.Fio) - (a.Fio < b.Fio))])];
            },
            setRoute: function(value) {
                this.isRouteLocal = value;
            },
            applyClick: function() {
                if(this.employees.some(e => e.Checked))
                    this.hideEmployeeTTModal();

                let displayTTs = this.isRouteLocal ? 'EmployesRoutes' : 'Employes';
                this.$emit('apply', displayTTs);
            },
            searchEmployeeTT: function(text) {
                if(!text) {
                    this.employees = this.options;
                    this.sortEmployees();
                }                    

                this.employees = this.options.filter(e => e.Fio.toLocaleLowerCase().includes(text.toLocaleLowerCase()));
            },
            sortEmployees: function(item) {
                this.$nextTick(function(){
                    if(this.employees && this.employees.length > 1)     
                        this.employees = [...new Set([...this.employees.filter(e => e.Checked), ...this.employees.sort((a, b) => (a.Fio > b.Fio) - (a.Fio < b.Fio))])];      
                });
                
            }
        }
}
</script>